export const ORGANIZATION_ROLES = Object.freeze({
  OWNER: 'owner',
  ADMIN: 'admin',
  BILLING_ADMIN: 'billingAdmin',
  ATTORNEY: 'attorney',
  STAFF: 'staff',
});

export const MEMBERSHIP_STATUSES = Object.freeze({
  INVITED: 'invited',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  REMOVED: 'removed',
});

export const CASE_ROLES = Object.freeze({
  CASE_LEAD: 'caseLead',
  COLLABORATOR: 'collaborator',
  OBSERVER: 'observer',
});

export const CASE_STATUSES = Object.freeze({
  DRAFT: 'draft',
  READY: 'ready',
  LIVE: 'live',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
});

export const PANEL_ROLES = Object.freeze({
  CASE_LEAD: 'caseLead',
  PRESENTER: 'presenter',
  COLLABORATOR: 'collaborator',
  NOTE_TAKER: 'noteTaker',
  OBSERVER: 'observer',
});

export const SUBSCRIPTION_PLANS = Object.freeze({
  FOUNDING_TEAM: 'foundingTeam',
  SOLO: 'solo',
  TEAM: 'team',
  OFFICE: 'office',
  PUBLIC_SECTOR: 'publicSector',
});

export const SUBSCRIPTION_STATUSES = Object.freeze({
  AWAITING_CHECKOUT: 'awaiting_checkout',
  PENDING_PAYMENT: 'awaiting_checkout',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  UNPAID: 'unpaid',
  CANCELED: 'canceled',
  BETA: 'beta',
});

export const ORGANIZATION_ROLE_LABELS = Object.freeze({
  [ORGANIZATION_ROLES.OWNER]: 'Owner',
  [ORGANIZATION_ROLES.ADMIN]: 'Administrator',
  [ORGANIZATION_ROLES.BILLING_ADMIN]: 'Billing administrator',
  [ORGANIZATION_ROLES.ATTORNEY]: 'Attorney',
  [ORGANIZATION_ROLES.STAFF]: 'Staff',
});

export const ACTIVE_ORGANIZATION_ROLES = Object.freeze([
  ORGANIZATION_ROLES.OWNER,
  ORGANIZATION_ROLES.ADMIN,
  ORGANIZATION_ROLES.BILLING_ADMIN,
  ORGANIZATION_ROLES.ATTORNEY,
  ORGANIZATION_ROLES.STAFF,
]);

export const canAdministerOrganization = (membership) =>
  membership?.status === MEMBERSHIP_STATUSES.ACTIVE &&
  [ORGANIZATION_ROLES.OWNER, ORGANIZATION_ROLES.ADMIN].includes(membership?.role);

export const canManageBilling = (membership) =>
  membership?.status === MEMBERSHIP_STATUSES.ACTIVE &&
  [
    ORGANIZATION_ROLES.OWNER,
    ORGANIZATION_ROLES.ADMIN,
    ORGANIZATION_ROLES.BILLING_ADMIN,
  ].includes(membership?.role);

export const canSeeEveryCase = (membership) =>
  membership?.status === MEMBERSHIP_STATUSES.ACTIVE &&
  [ORGANIZATION_ROLES.OWNER, ORGANIZATION_ROLES.ADMIN].includes(membership?.role);

export const consumesSeat = (membership) =>
  membership?.status === MEMBERSHIP_STATUSES.ACTIVE &&
  ACTIVE_ORGANIZATION_ROLES.includes(membership?.role);

export const membershipDocumentId = (scopeId, userId) => `${scopeId}_${userId}`;

export const getDisplayName = (user, profile = {}) => {
  const fullName = [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim();
  return fullName || user?.displayName || user?.email || 'Workspace member';
};

export const normalizeCaseStatus = (value) =>
  Object.values(CASE_STATUSES).includes(value) ? value : CASE_STATUSES.DRAFT;
